import React, { useMemo, useCallback } from 'react';
import cx from 'clsx';

import { IconOfflineBotAvatar, IconBotAvatar } from '@/assets/bot';
import { UserAvatar, UserCardPopup, UserCardPopupPropsPartial } from '@/components';
import { isEthAddress, openNewWindow } from '@/utils';

import style from './index.module.scss';

type Props = {
  className?: string;
  size?: number;
  userIconSize?: number;
  userDesc?: UserDesc;
  isOffline?: boolean;
  onClick?(e: React.MouseEvent<HTMLDivElement>): void;
  userCardPopup?: UserCardPopupPropsPartial;
};

export const BotAvatar = ({
  className,
  size = 48,
  userIconSize = 20,
  userDesc,
  isOffline,
  onClick,
  userCardPopup = true,
}: Omit<Props, 'UserCardPopupPropsPartial'>) => {
  const sizeStyle = useMemo(() => ({ width: size, height: size }), [size]);
  const offsetStyle = useMemo(() => {
    const offset = size * (6 / 80);

    return { bottom: -offset, right: -offset };
  }, [size]);

  const userId = userDesc?.id;

  const handleUserClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();

      if (isEthAddress(userId)) openNewWindow(`/profile/${userId}`, '_blank');
    },
    [userId],
  );

  const BotAvatarInner = (
    <UserAvatar
      className={style.userAvatar}
      size={userIconSize}
      data={userDesc}
      style={offsetStyle}
      enableOfficialLogo={false}
      onClick={handleUserClick}
    />
  );

  return (
    <div className={cx(style.avatar, className)} onClick={onClick} style={sizeStyle}>
      <img
        alt=""
        src={isOffline ? IconOfflineBotAvatar : IconBotAvatar}
        className={style.botIcon}
      />
      {userCardPopup && userId ? (
        <UserCardPopup {...(userCardPopup === true ? {} : userCardPopup)} address={userId}>
          {BotAvatarInner}
        </UserCardPopup>
      ) : (
        BotAvatarInner
      )}
    </div>
  );
};
